var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMailLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.62615 3.14937V13.772H0.273438V0.513672L0.524325 0.673428L8.67345 6.21864C8.76883 6.29544 8.88581 6.3371 9.00617 6.3371C9.12654 6.3371 9.24351 6.29544 9.33889 6.21864L17.4771 0.684849L17.728 0.513672V13.772H16.3862V3.2064L16.1462 3.35474C14.1389 4.71252 12.1316 6.07033 10.1243 7.45094C9.80232 7.70546 9.40977 7.84315 9.00617 7.84315C8.60257 7.84315 8.20995 7.70546 7.88796 7.45094C5.88069 6.07033 3.87346 4.71252 1.86619 3.35474L1.62615 3.14937Z",
    fill: "url(#paint0_linear_721_19519)",
    stroke: "url(#paint1_linear_721_19519)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_721_19519",
    x1: 16.8093,
    y1: 13.772,
    x2: -0.160598,
    y2: 3.51021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#383838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8264F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_721_19519",
    x1: 16.8093,
    y1: 13.772,
    x2: -0.160598,
    y2: 3.51021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#383838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8264F9"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailLogo);
export default __webpack_public_path__ + "static/media/mailLogo.69a6bfd0ee9e71c549a47da5af2c26d4.svg";
export { ForwardRef as ReactComponent };